import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Registered() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load providers from API
  useEffect(() => {
    const fetchProviders = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/providers`);
        if (response.ok) {
          const data = await response.json();
          setProviders(data);
        } else {
          console.error('Failed to fetch providers');
        }
      } catch (error) {
        console.error('Error fetching providers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, []);

  const filteredProviders = providers.filter(provider =>
    provider.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    provider.specialization.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="tab-content">
      <h2>Verified Providers Directory</h2>

      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search by name or specialization..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            border: '2px solid #3498db',
            borderRadius: '8px'
          }}
        />
      </div>

      {loading ? (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontSize: '18px',
          color: '#666'
        }}>
          Loading verified providers...
        </div>
      ) : (
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#2c3e50', marginBottom: '20px' }}>
            Verified Providers ({filteredProviders.length})
          </h3>
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
            Click on any provider to see detailed information
          </p>

          {filteredProviders.length > 0 ? (
          <ul className="list-container">
            {filteredProviders.map((provider) => (
              <li key={provider.id} className="list-item">
                <div
                  className="item-name"
                  onClick={() => setSelectedProvider(selectedProvider === provider.id ? null : provider.id)}
                  style={{ cursor: 'pointer' }}
                >
                  ✓ {provider.name}
                  <span style={{
                    marginLeft: '15px',
                    fontSize: '14px',
                    color: '#27ae60',
                    fontWeight: 'normal'
                  }}>
                    - {provider.specialization}
                  </span>
                </div>

                <div className={`hover-details ${selectedProvider === provider.id ? 'active' : ''}`}>
                  <h3>✓ {provider.name}</h3>

                  <div style={{ marginBottom: '15px' }}>
                    <p><strong>Registration ID:</strong> {provider.id}</p>
                    <p><strong>Status:</strong> <span style={{ color: '#27ae60' }}>{provider.status}</span></p>
                  </div>

                  {/* QR Code Section - Enhanced */}
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    border: '2px solid #3498db',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}>
                    {/* Header */}
                    <div style={{
                      backgroundColor: '#3498db',
                      color: 'white',
                      padding: '10px',
                      borderRadius: '8px',
                      marginBottom: '15px',
                      textAlign: 'center'
                    }}>
                      <p style={{
                        margin: 0,
                        fontSize: '14px',
                        fontWeight: 'bold',
                        letterSpacing: '0.5px'
                      }}>
                        ✓ VERIFIED PROVIDER
                      </p>
                      <p style={{
                        margin: '5px 0 0 0',
                        fontSize: '11px',
                        opacity: 0.9
                      }}>
                        {provider.status}
                      </p>
                    </div>

                    {/* QR Code */}
                    <div style={{
                      backgroundColor: 'white',
                      padding: '20px',
                      borderRadius: '8px',
                      display: 'inline-block',
                      border: '1px solid #ddd',
                      marginBottom: '15px'
                    }}>
                      <QRCodeSVG
                        value={`${window.location.origin}?provider=${provider.id}`}
                        size={200}
                        level="H"
                        includeMargin={true}
                      />
                    </div>

                    {/* Provider IDs */}
                    <div style={{
                      backgroundColor: 'white',
                      padding: '12px',
                      borderRadius: '8px',
                      marginBottom: '12px',
                      border: '1px solid #e0e0e0'
                    }}>
                      <p style={{
                        margin: '0 0 6px 0',
                        fontSize: '12px',
                        color: '#666',
                        fontWeight: '600'
                      }}>
                        Provider ID: <span style={{ color: '#2c3e50', fontWeight: 'bold' }}>{provider.id}</span>
                      </p>
                      {provider.barcodeId && (
                        <p style={{
                          margin: 0,
                          fontSize: '12px',
                          color: '#666',
                          fontWeight: '600'
                        }}>
                          Barcode: <span style={{ color: '#2c3e50', fontWeight: 'bold' }}>{provider.barcodeId}</span>
                        </p>
                      )}
                    </div>

                    {/* Key Information Grid */}
                    <div style={{
                      backgroundColor: 'white',
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      textAlign: 'left'
                    }}>
                      {/* Location */}
                      {provider.location && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>📍</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Location</span>
                            <span style={{ fontSize: '13px', color: '#2c3e50', fontWeight: '600' }}>{provider.location}</span>
                          </div>
                        </div>
                      )}

                      {/* Rating */}
                      {provider.rating && provider.rating !== 'N/A' && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>⭐</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Rating</span>
                            <span style={{ fontSize: '13px', color: '#f39c12', fontWeight: 'bold' }}>{provider.rating}</span>
                          </div>
                        </div>
                      )}

                      {/* Experience */}
                      {provider.completedProjects && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>💼</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Experience</span>
                            <span style={{ fontSize: '13px', color: '#2c3e50', fontWeight: '600' }}>{provider.completedProjects}</span>
                          </div>
                        </div>
                      )}

                      {/* Specialization */}
                      {provider.specialization && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>🎯</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Specialization</span>
                            <span style={{ fontSize: '13px', color: '#3498db', fontWeight: '600' }}>{provider.specialization}</span>
                          </div>
                        </div>
                      )}

                      {/* Email */}
                      {provider.email && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>📧</span>
                          <div style={{ overflow: 'hidden' }}>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Email</span>
                            <a href={`mailto:${provider.email}`} style={{
                              fontSize: '12px',
                              color: '#3498db',
                              textDecoration: 'none',
                              wordBreak: 'break-word'
                            }}>
                              {provider.email}
                            </a>
                          </div>
                        </div>
                      )}

                      {/* Phone */}
                      {provider.phone && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>📱</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Phone</span>
                            <a href={`tel:${provider.phone}`} style={{
                              fontSize: '13px',
                              color: '#27ae60',
                              textDecoration: 'none',
                              fontWeight: '600'
                            }}>
                              {provider.phone}
                            </a>
                          </div>
                        </div>
                      )}

                      {/* Website */}
                      {provider.website && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>🌐</span>
                          <div style={{ overflow: 'hidden' }}>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Website</span>
                            <a href={provider.website.startsWith('http') ? provider.website : `https://${provider.website}`}
                               target="_blank"
                               rel="noopener noreferrer"
                               style={{
                                 fontSize: '12px',
                                 color: '#3498db',
                                 textDecoration: 'none',
                                 wordBreak: 'break-word'
                               }}>
                              {provider.website}
                            </a>
                          </div>
                        </div>
                      )}

                      {/* Verified Since */}
                      {provider.verifiedSince && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', marginRight: '8px' }}>✅</span>
                          <div>
                            <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>Verified Since</span>
                            <span style={{ fontSize: '13px', color: '#27ae60', fontWeight: '600' }}>{provider.verifiedSince}</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Footer Note */}
                    <p style={{
                      marginTop: '12px',
                      marginBottom: 0,
                      fontSize: '10px',
                      color: '#888',
                      textAlign: 'center',
                      fontStyle: 'italic'
                    }}>
                      Scan QR code for instant access to provider details
                    </p>
                  </div>

                  {/* Additional Information (if needed in future) */}
                  {provider.founded && (
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#e8f5e9',
                      borderRadius: '8px',
                      border: '1px solid #c8e6c9',
                      marginTop: '15px'
                    }}>
                      <p style={{ fontSize: '12px', margin: '0', color: '#2c3e50' }}>
                        <strong>Founded:</strong> {provider.founded}
                      </p>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ textAlign: 'center', color: '#888', fontSize: '16px' }}>
            No providers found matching your search criteria.
          </p>
        )}
        </div>
      )}

    </div>
  );
}

export default Registered;
